import React from "react";
import FirstPart from "./FirstPart";
import SecondPart from "./SecondPart";

const PageTwo = () => {
  return (
    <div>
      <FirstPart />
      <SecondPart />
    </div>
  );
};

export default PageTwo;
